export enum HttpEventsObserveType {
  Body = 'body',
  Events = 'events',
  Response = 'response'
}
